// extracted by mini-css-extract-plugin
module.exports = {"slider-arrow-icon":"SliderArrow_slider-arrow-icon__2H-bj"};